<template>
  <div class="box">
    <v-row class="">
      <v-col class="noYPadding">
        <VTextField
          v-model="data.text"
          :label="$t('treatmentProgram.step2.text')"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';

export default {
    name: 'Schedule',
    components: {
        VTextField,
    },
    props: {
        model: {
            type: Object,
            default: () => {},
        },
        objectKey: {
            type: String,
            default: '',
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        ...mapGetters([
            'treatmentProgramUnits',
        ]),
    },
    watch: {
        model: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.model) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { [this.objectKey]: this.data });
        },
        displayedUnits(type) {
            return this.treatmentProgramUnits && this.treatmentProgramUnits[type]
                ? this.treatmentProgramUnits[type] : [];
        },
        isTrue(property) {
            return property === 0;
        },
    },
};
</script>
<style lang="scss" scoped>
.noYPadding {
    padding-bottom: 0px;
    padding-top: 0px;
}
.box {
    width: 100%;
    padding: 0 1rem;
}
.xPadding{
  padding: 0 6rem;
}
</style>
